<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Callcentre-Member",
  path: "member",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
